<template>
     <div class="mainButton">
        <ul class="nav_breadcrumbs">
            <li><router-link to="/modules/home">{{lang.Home}}</router-link></li>
            <li><router-link to="/modules/account">{{lang.LBL_PROFILE}}</router-link></li>
        </ul>
     </div>  
</template>
<script>
import lang from "@/views/modules/Accounts/language/en";
export default {
    name: "breadcrumbs",
    data() {
        return {
            lang:[],
        }
     },
     mounted() {
        this.lang = lang;
    },
     
}
</script>
